import { render, staticRenderFns } from "./OrderCreateModal.vue?vue&type=template&id=97596ebc&scoped=true"
import script from "./OrderCreateModal.vue?vue&type=script&lang=js"
export * from "./OrderCreateModal.vue?vue&type=script&lang=js"
import style0 from "./OrderCreateModal.vue?vue&type=style&index=0&id=97596ebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97596ebc",
  null
  
)

export default component.exports